<template>
	<div>

		<div class="r-title">
			<img src="../../assets/imgs/news/news-title-bg.png" class="r-title-bg">
			<span style="z-index: 1;position: relative;">Inquiry record</span>
		</div>

		<div>
			<div class="df fdc wow fadeInUp animated">
				<div class="items hover-up transition-normal fadeIn" v-for="(item, index2) in data" :key="index2"
					@click="detail(item)">
					<div class="df aic" v-if="item.user">
						<img class="avatar" style="width: 30px;height: 30px;" :src="item.user.avatar" alt="" />
						<div class="user-name" v-text="item.user.username"></div>
					</div>
					<div class="df text_over" style="margin-top: 0.5rem;">
						<div class="df aic" style="margin-right: 1rem;">
							<div class="value">Name: </div>
							<div class="label">{{item.name}}</div>
						</div>
						<div class="df aic" style="margin-right: 1rem;">
							<div class="value">Contact: </div>
							<div class="label">{{item.contact}}</div>
						</div>
						<div class="df aic" v-if="!isMobile">
							<div class="value">service: </div>
							<a style="color:#2284E6;text-decoration: underline;" class="label" v-if="item.provider">{{item.provider.providerName}}</a style="color:#2284E6;">
						</div>
					</div>
					<div class="df aic" v-if="isMobile">
						<div class="value">service: </div>
						<a style="color:#2284E6;text-decoration: underline;" class="label" v-if="item.provider">{{item.provider.providerName}}</a style="color:#2284E6;">
					</div>
					<div class="subTitle text_over_2line">{{item.content}}</div>
					<div class="df aic" v-if="item.product||item.productCustom"
						style="font-weight: bold;border: 1px solid #DEDEDE;padding: 1rem;margin-top: 1rem;background-color: #FAFAFA;">
						<img v-if="item.product" :src="item.product.main_pics[0]" width="40px"
							height="40px" alt="" />
						<span style="font-weight: bold;margin-left: 1rem;" v-if="item.product">{{item.product.title}}</span>
						<span style="font-weight: bold;margin-left: 1rem;" v-if="item.productCustom">{{item.productCustom.title}}</span>
					</div>
				</div>
				<div v-show="data.length==0&&!loading" class="nodata-box">
					<img src="../../assets/imgs/nodata.svg" class="nodata-img">
				</div>
			</div>
		</div>
		<pagination :pageSizeList="[]" :page="params.page" :page-size="params.perPage" :total="nowtotal||0"
			:on-page-change="onPage" class="pagi page-content" />
	</div>
</template>

<script>
	import Pagination from '@/components/pagination.vue';
	export default {
		data() {
			return {
				data: [],
				loading: true,
				nowtotal:0,
				params: {
					perPage: 6,
					page: 1,
				},
				isMobile:false
			}
		},
		components: {
			Pagination
		},
		methods: {
			detail(item){
				if(item.productCustom){
					this.$router.push({name: 'demandDetails',query:{id:item.productCustomId}})
				}else{
					this.$router.push({name: 'productDetail',query:{id:item.pid}})
				}
			},
			// 分页
			onPage(pageNow) {
				this.params.page = pageNow;
				window.scrollTo(0, 0);
				this.getdata()
			},
			async getdata() {
				this.loading = true
				let {
					data
				} = await this.$get('/gci/product/enquires',this.params)
				this.data = data.items
				this.nowtotal = data.total
				this.loading = false
			}
		},
		mounted() {
			this.isMobile = localStorage.getItem('isMobile') == 'null' ? false : true
			this.getdata()
		}
	}
</script>

<style lang="scss" scoped>
	
	.user-name{
		margin-left:0.5rem;
	}
	.items {
		overflow: hidden;
		cursor: pointer;
		padding: 1rem;
		margin-top: 1rem;
		border-radius: 0.5rem;
		border: 1px solid #e8e8e8;
	}

	.r-title {
		height: 3rem;
		font-size: 1.5rem;
		font-weight: bold;
		position: relative;

		.r-title-bg {
			width: 13rem;
			position: absolute;
			left: -0.5rem;
			top: -2rem
		}
	}
	.subTitle{
		margin:1rem 0;
	}
	.avatar {
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		border-radius: 50%;
	}
	.label{
		font-weight: bold;
		margin-left: 0.3rem;
	}
</style>